const SendIcon = (props :any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M21 17.198H6.4v-2.4H21l-6.7-6.7 1.7-1.7 9.6 9.6-9.6 9.6-1.7-1.7 6.7-6.7Z"
    />
  </svg>
)
export default SendIcon
